<template>
  <FormGroup :label="label" :inputId="idCalc" :errors="errorsCalc" :successes="successes">
    <!-- TODO: wrap this in password strength meter (there's a vue package) -->
    <input
      class="form-control"
      type="password"
      :class="{ 'is-invalid': errorsCalc, 'is-valid': successes }"
      :data-test="testId"
      :id="idCalc"
      :name="name"
      :placeholder="placeholder"
      :value="value"
      :disabled="disabled"
      @input="emitInput"
      @change="emitChange"
    />
  </FormGroup>
</template>

<script>
import FormGroup from "@/components/display/form/FormGroup";
import FormMixin from "@/components/display/form/FormMixin";

export default {
  name: "FormPassword",
  components: {
    FormGroup,
  },
  mixins: [FormMixin],
  props: {
    type: {
      type: String,
      default: "text",
    },
    value: [String, Number],
  },
  setup(props, { emit }) {
    const emitInput = (e) => {
      emit("input", e.target.value);
    };

    const emitChange = (e) => {
      emit("change", e.target.value);
    };

    return {
      emitChange,
      emitInput,
    };
  },
};
</script>

<style lang="scss" scoped></style>
